import React from 'react';
import type {
	FormEnrollment as FormEnrollmentModel,
	FormEnrollmentDto,
} from 'models/enrollments/FormEnrollment';
import { FormViewer } from 'components/forms/FormViewer';
import type { UserSubmissionDto } from 'models/projects/UserSubmissionDto';

type Props = {
	enrollment: FormEnrollmentModel | FormEnrollmentDto;
	className?: string;
	onSubmit?: (submissionDto: UserSubmissionDto) => void;
	workflowId?: string;
	nodeId?: string;
	projectId?: string;
	teamId?: string;
	isDisabled?: boolean;
};

const getFormId = (enrollment: FormEnrollmentModel | FormEnrollmentDto): string => {
	if ('formId' in enrollment && typeof enrollment.formId === 'string') {
		return enrollment.formId;
	}
	return '';
};

export const FormEnrollmentView: React.FC<Props> = ({ enrollment, className = '', onSubmit, workflowId, nodeId, projectId, teamId, isDisabled }) => {
	return (
		<FormViewer
			form={null}
			isDisabled={isDisabled ?? false}
			formId={getFormId(enrollment)}
			onSubmit={onSubmit}
			workflowId={workflowId}
			nodeId={nodeId}
			projectId={projectId}
			teamId={teamId}
		/>
	);
};

export default FormEnrollmentView;
